/**
 * The plain line the CRF Builder shows under a question's answer options, from
 * the `codesFrom` the order of authority stamped on it
 * (functions/src/crf/crfAuthority.ts, 2026-10-02). Sources look like
 * "sponsor dictionary", "protocol section 9.3", "CDASH (AESEV)", "generic list".
 */

const PREFIX = 'Answer codes from: ';

/** The sentence for one source, or null when no source is stated. */
export function answerCodesLine(codesFrom: unknown): string | null {
  if (typeof codesFrom !== 'string') return null;
  const s = codesFrom.trim();
  if (!s) return null;

  let m = /^sponsor dictionary\b\s*(.*)$/i.exec(s);
  if (m) return `${PREFIX}your data dictionary${m[1] ? ` ${m[1]}` : ''}`;

  m = /^protocol\s+section\s+(.+)$/i.exec(s);
  if (m) return `${PREFIX}the protocol, section ${m[1]}`;
  if (/^protocol$/i.test(s)) return `${PREFIX}the protocol`;

  m = /^CDASH\b\s*(.*)$/i.exec(s);
  if (m) return `${PREFIX}the CDASH standard${m[1] ? ` ${m[1]}` : ''}`;

  m = /^(?:generic list|platform default)\b\s*(.*)$/i.exec(s);
  if (m) return `${PREFIX}the standard list${m[1] ? ` ${m[1]}` : ''}`;

  return `${PREFIX}${s}`;
}
